import { Response } from 'express'
import { IPage } from 'marketing-site/@types/generated/contentful'
import { getAssignedVariations } from 'marketing-site/lib/abTests'
import getLocaleCodeAndPathFromUri from 'marketing-site/lib/getLocaleAndPathFromUri'
import getPageByPath from 'marketing-site/lib/getPageByPath'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import Page from 'marketing-site/src/components/common/Page'
import { IAssignedVariations } from 'marketing-site/src/components/context/AssignedVariationsContext'
import { GetServerSideProps } from 'next'
import React from 'react'
import { getServerSideProps as getErrorServerSideProps } from '../_error'

interface IProps {
  page: IPage
  assignedVariations: IAssignedVariations
}

export default function ContentfulPage({ page }: IProps) {
  return (
    <EntryMarker entry={page}>
      <Page page={page} />
    </EntryMarker>
  )
}

export const getServerSideProps: GetServerSideProps<IProps> = async function ({
  query,
  req,
  res,
  resolvedUrl,
}) {
  if (typeof query.customerSlug == 'string') {
    query.customerSlug = [`customers/${query.customerSlug}`]
  }

  const { path, locale } = await getLocaleCodeAndPathFromUri(query.customerSlug)

  const page = await getPageByPath(path, locale)
  if (!page) {
    ;(res as Response).redirect('/customers')
    return getErrorServerSideProps({ req, res, query: {}, resolvedUrl })
  }
  const assignedVariations = await getAssignedVariations(req, page)

  return {
    props: { page, assignedVariations },
  }
}
